import { yupResolver } from '@hookform/resolvers/yup';
import { Link, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import * as yup from 'yup';
import LoginButton from 'components/Buttons/LoginButton';
import { notify } from 'components/Notifier';
import { AppContext } from 'context';
import Layout from 'pages/Login/Layout';

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexFlow: 'column',

    '& > *': {
      marginBottom: '1rem',
    },

    '& > h2': {
      marginTop: 0,
    },
  },
});

const LostPasswordForm: React.FC = () => {
  const history = useHistory();
  const context = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation();

  const schema = yup.object().shape({
    email: yup.string().email(t('loginForm.validation.invalidEmail')).required(t('loginForm.validation.requiredEmail')),
  });

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async (values: any) => {
    try {
      await context.resetPassword(values);
      history.push('/');
      notify({
        message: t('loginForm.resetEmailSucess'),
        severity: 'success',
      });
    } catch (e) {
      notify({
        message: t('loginForm.resetEmailError'),
        severity: 'error',
      });
    }
  };

  return (
    <Layout title={t('loginForm.forgottenPasswordTitle')}>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="email"
          control={control}
          render={({ field: { ref, ...fieldProps }, fieldState: { error } }) => (
            <TextField
              label={t('loginForm.email')}
              error={!!error}
              helperText={error?.message}
              inputRef={ref}
              {...fieldProps}
            />
          )}
        />
        <LoginButton disabled={isSubmitting}>{t('loginForm.resetPassword')}</LoginButton>
      </form>
      <Link component={RouterLink} to="/">
        {t('loginForm.backToLoginLink')}
      </Link>
    </Layout>
  );
};

export default LostPasswordForm;
